import { render, staticRenderFns } from "./ReviewsSettingsCellRendererRating.vue?vue&type=template&id=c5c71a4e&scoped=true&"
import script from "./ReviewsSettingsCellRendererRating.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettingsCellRendererRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c71a4e",
  null
  
)

export default component.exports